import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=4702547e&scoped=true&"
import script from "./Knowledge.vue?vue&type=script&lang=js&"
export * from "./Knowledge.vue?vue&type=script&lang=js&"
import style0 from "./Knowledge.vue?vue&type=style&index=0&id=4702547e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4702547e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4702547e')) {
      api.createRecord('4702547e', component.options)
    } else {
      api.reload('4702547e', component.options)
    }
    module.hot.accept("./Knowledge.vue?vue&type=template&id=4702547e&scoped=true&", function () {
      api.rerender('4702547e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/Knowledge.vue"
export default component.exports